import { useEffect, useState } from 'react';
import useDelete from '../../hook/useDelete';
import { delete_MyCdirAchInfo, getMyCdirACHInfoWithTenantId } from '../../services/ACHInfo';
import Cookies from 'js-cookie';
import Pagination from '../../components/Pagination';
import { formatUSPhone } from '../../utils/phoneFormatter';
import useGroup from '../../hook/useGroup';

const heading = ["#", "Account Number", "Account Type", "Name", "Routing Number", "Phone Number"];

type ACHDetailsProps = {
    isRefresh: boolean;
    setIsRefresh: (value: boolean) => void;
    setShowPopupAddNewACH: (value: boolean) => void;
}

const ACHDetails = ({
    isRefresh,
    setIsRefresh,
    setShowPopupAddNewACH
}: ACHDetailsProps) => {
    const { selectedTenantId, isSuperAdmin }: any = useGroup();
    const tenantId = isSuperAdmin
        ? selectedTenantId
        : Cookies.get("tenantId-my-cdir");
    const userId = Cookies.get("userId-my-cdir");
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [achData, setAChData] = useState<any[]>([]);
    const [paginationModel, setPaginationModel] = useState<{ page: number, size: number }>({
        page: 0,
        size: 10
    });
    const [totalLength, setTotalLength] = useState<number>(0);
    const [showEntries, setShowEntries] = useState<number>(10);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isRefresh) {
            setIsRefresh(false);
            setPaginationModel({
                ...paginationModel,
                page: 0
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRefresh])

    useEffect(() => {
        if (tenantId) {
            setLoading(true);
            getMyCdirACHInfoWithTenantId(tenantId, paginationModel.page, paginationModel.size)
                .then(res => {
                    setTotalLength(res?.count);
                    setAChData(res?.mycdirACHInfo);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tenantId, isRefresh])

    const deleteACH = (primaryKey: number) => {
        setDeleteData({
            id: primaryKey,
            tilte: `Delete`,
            summary: `Are you sure you want to delete this ACH Info?`,
            isDelete: (callback: any) => {
                if (userId)
                    delete_MyCdirAchInfo(primaryKey, userId?.toString())
                        .then(() => {
                            setIsRefresh(true);
                            callback();
                        })
                        .catch(error => console.error(error))
            }
        });

        setDeletePopup(true);
    }

    return (
        <div className="w-full border border-secondary rounded-md bg-primary">
            <h4 className="text-primary font-medium bg-secondary px-4 py-2 w-full">ACH Info</h4>

            <div className="flex flex-col p-4 gap-y-3">

                <table>
                    <thead className="border-b-2 border-secondary">
                        <tr className="text-sm text-start">
                            {heading.map((item, index) => (
                                <th key={index} className="border-r border-secondary text-start px-0.5">
                                    {item}
                                </th>
                            ))}
                            <th className="text-start px-0.5 !pl-1.5 text-secondary font-bold select-none"></th>
                        </tr>
                    </thead>

                    <tbody className="border-b border-secondary">
                        {loading ? (
                            <tr>
                                <td
                                    colSpan={7}
                                    className="py-12"
                                >
                                    <div className="flex flex-col items-center justify-center gap-2">
                                        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-300 border-t-[#2B3998]" />
                                        <span className="text-sm text-gray-500">
                                            Loading...
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            achData?.map((item: any, index: number) => (
                                <tr
                                    key={index}
                                    className="text-sm text-start"
                                >
                                    <td className="border-r border-b border-secondary text-start px-0.5 py-1.5">{item?.id}</td>
                                    <td className="border-r border-b border-secondary text-start px-0.5 py-1.5">{item?.accountNumber}</td>
                                    <td className="border-r border-b border-secondary text-start px-0.5 py-1.5">{item?.accountType}</td>
                                    <td className="border-r border-b border-secondary text-start px-0.5 py-1.5">{item?.bankName}</td>
                                    <td className="border-r border-b border-secondary text-start px-0.5 py-1.5">{item?.routingNumber}</td>
                                    <td className="border-r border-b border-secondary text-start px-0.5 py-1.5">{formatUSPhone(item?.bankPhone || "")}</td>
                                    <td
                                        className="text-start border-b border-secondary px-0.5 !pl-1.5 py-1.5 hover:text-secondary active:text-custom-blue font-bold cursor-pointer select-none"
                                        onClick={() => deleteACH(item?.id)}
                                    >
                                        {"X"}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

                <Pagination
                    totalLength={totalLength}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    setIsRefresh={setIsRefresh}
                    showEntries={showEntries}
                    setShowEntries={setShowEntries}
                />

            </div>

        </div>
    )
}

export default ACHDetails
